<template>
    <div class="rendered">
        <div class="rendered-grid" v-if="pdfs">
            <div v-for="(pdf,index,key) in sortedPdf" :key="pdf.name">
                <div class="image-border">
                    <img :src="`${pdf.fullUrl}`">
                    <!--                    <img :src="`${pdf.fullUrl}?preview&width=600`">-->
                    <!--                    <a :href="pdf.fullUrl" target="_blank">full size image</a>-->
                </div>
                <div style="text-align: center">
                    <a :href="pdf.fullUrlPdf">Render Quality: {{pdf.pixelRatio}} (pdf link)</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'TxRenderedPdfs',
        data() {
            return {
                pdfs: null
            }
        },
        computed: {
            config() {
                return lovemap.config
            },
            order_id() {
                return order_id
            },
            ID() {
                return ID
            },
            sortedPdf() {
                return this.pdfs
            }
        },
        created() {
            this.getList();
            this._interval = setInterval(this.getList, 10000);
        },
        beforeDestroy() {
            clearInterval(this._interval);
        },
        methods: {
            async getList() {
                const {data} = await this.$http({
                    method: 'GET',
                    url: `${lovemap.rest}lm/v1/lovemap/list/${this.ID}`,
                    headers: {'X-WP-Nonce': lovemap.nonce}
                });
                console.log(data)
                this.pdfs = data;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .rendered-grid {
        margin-top: 10px;

        display: grid;
        grid-column-gap: 15px;
        grid-row-gap: 25px;
        grid-template-columns: minmax(20%, 1fr) minmax(20%, 1fr) minmax(20%, 1fr) minmax(20%, 1fr);
        grid-template-areas: ". . . .";

        img {
            max-width: 100%;
            height: auto;
        }

        a {
            text-decoration: none;
            font-size: 15px;

            &:hover {
                text-decoration: none;
            }
        }
    }

    .image-border {
        border: 1px dashed #ccc;
    }
</style>